<template>
  <el-select :disabled="disabled" filterable v-model="useModel" :clearable="true" placeholder="Select" v-loading="isLoading">
    <el-option v-for="division in divisionList" :value="division.id" :label="division.name" :key="division.id">
    </el-option>
  </el-select>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  props: {
    inputModel: {
      default: 0
    },
    clearable: {
      default: false
    },
    disabled: {
      default: false
    }
  },
  data () {
    return {
      divisionList: [],
      isLoading: true
    }
  },
  computed: {
    useModel: {
      get: function () {
        return this.inputModel
      },
      set: function (modifiedValue) {
        this.$emit('input', modifiedValue)
      }
    }
  },
  watch: {
    inputModel: function () {
      if (this.useModel && !(this.divisionList.some(e => e.id === this.useModel))) {
        this.fetchDivisionInfo(this.useModel)
      }
    }
  },
  methods: {
    fetchDivisionList () {
      this.isLoading = true
      if (sessionStorage.getItem('allDivisionList')) {
        this.divisionList = JSON.parse(sessionStorage.getItem('allDivisionList'))
        this.isLoading = false
      } else {
        var call = '/getAllPEADivisionList'
        this.$axios.get(call).then(response => {
          const unsortedList = response.data
          const sortedList = unsortedList.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)
          this.divisionList = sortedList
          sessionStorage.setItem('allDivisionList', JSON.stringify(this.divisionList))
          this.isLoading = false
        }).catch(reject => {
          this.isLoading = false
          if (this.$route.name === 'PEA') {
            helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Division List', reject.body, 'error', 30000, '')
          } else if (this.$route.name === 'Custom Grouping Reports') {
            helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Division List', reject.body, 'error', 30000, '')
          } else if (this.$route.name === 'advancedSearch') {
            helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Division List', reject.body, 'error', 30000, '')
          }
        })
      }
    },
    fetchDivisionInfo (id) {
      this.isLoading = true
      var call = '/getPEADivisionById/' + id
      this.$axios.get(call).then(response => {
        this.divisionList.push(response.data)
        this.isLoading = false
      }).catch(reject => {
        this.isLoading = false
        if (this.$route.name === 'PEA') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Division List', reject.body, 'error', 30000, '')
        } else if (this.$route.name === 'Custom Grouping Reports') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Division List', reject.body, 'error', 30000, '')
        } else if (this.$route.name === 'advancedSearch') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Division List', reject.body, 'error', 30000, '')
        }
      })
    }
  },
  created () {
    this.fetchDivisionList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
